// src/app/page.tsx
import { FC, useEffect, useState } from "react";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { adjustToggle } from "../../../utils/adjustToggle";
import BoLogo from "../../../assets/images/logo.svg";
import Grid from "@mui/material/Grid2";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import "./index.css";
import { CustomButton } from "../../../components/Button";
import AddIcon from "../../../assets/images/add-icon.svg";
import AddIconLight from "../../../assets/images/add-light.svg";
import { useNavigate } from "react-router-dom";

const RobotPreferences: FC = () => {
  const robots = [
    { name: "Bo", id: 1 },
    { name: "Talha", id: 2 },
    { name: "Ana", id: 3 },
    { name: "Sam", id: 4 },
  ];

  const theme = useTheme();
  const navigate = useNavigate();

  const boBox = (robot: { name: string; id: number }, i: number) => {
    return (
      <div className="pref" key={i}>
        <Grid container alignItems={"center"} sx={{ height: "100%" }}>
          <Grid size={{ xs: 2, md: 1 }} textAlign={"left"}>
            <img src={BoLogo} className="bot-img" />
          </Grid>
          <Grid size={{ xs: 2, md: 1 }} textAlign={"left"}>
            <Typography component="div" className="bot-name">{robot.name}</Typography>
          </Grid>
          <Grid size={{ xs: 8, md: 10 }} textAlign={"end"}>
            <DriveFileRenameOutlineIcon
              className="edit-icon"
              onClick={() => navigate(`/manage-robot/${robot.id}`)}
            />
          </Grid>
        </Grid>
      </div>
    );
  };

  return (
    <div className="bot-prefs">
      <Typography component="div" className="page-head">Edit Robot Preferences</Typography>
      <Stack sx={{ width: "100%" }}>
        {robots.map((robot, i) => {
          return boBox(robot, i);
        })}
        <CustomButton
          text={"Add a Bot"}
          startIcon={
            <img
              src={theme.palette.mode == "dark" ? AddIcon : AddIconLight}
              alt="new-chat"
              style={{ width: "20px", height: "20px" }}
            />
          }
          submit={() => console.log("gmail")}
          color={theme.palette.background.default}
          bgcolor="rgba(33, 143, 84, 1)"
          fontWeight="bold"
          width="100%"
          height="75px"
        />
      </Stack>
    </div>
  );
};

export default RobotPreferences;
